import { Component, OnInit, Directive, Input, HostBinding } from '@angular/core';

@Component({
	selector: 'app-shimmer',
	templateUrl: './shimmer.component.html',
	styleUrls: [ './shimmer.component.scss' ]
})
export class ShimmerComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}

@Directive({
	selector: 'transparent'
})
export class ShimmerTransparent {
	@Input() sizeX: any = '100%';
	@Input() sizeY: any = '10px';
	@HostBinding('style.width') private width = this.sizeX;
	@HostBinding('style.height') private height = this.sizeY;
}

@Directive({
	selector: 'obstacle'
})
export class ShimmerObstacle {
	@Input() color: any = 'red';
	@HostBinding('style.background') private background = this.color;
}
